import { createContext, useContext } from 'react';
export const FieldActionsContext = /*#__PURE__*/createContext({});
export function useFieldActions() {
  return useContext(FieldActionsContext);
}
//# sourceMappingURL=field-actions-context.js.map